import { APPOINTMENT_STEPS } from "@/lib/site-data";

export default function Process() {
  return (
    <section className="py-20 md:py-28 bg-brand-muted/60" data-testid="process-section">
      <div className="container-site">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <p className="overline mb-3">The patient journey</p>
            <h2 className="font-serif text-4xl md:text-5xl text-brand-pine leading-tight">
              We keep it <span className="italic text-brand-clay">super simple.</span>
            </h2>
            <p className="mt-5 text-brand-textMuted leading-relaxed">
              From your first enquiry to the final smile, every step is designed
              to feel effortless — especially for seniors, bed-ridden parents
              and busy families.
            </p>
          </div>

          <div className="lg:col-span-8 relative">
            <div className="absolute left-5 top-2 bottom-2 w-px bg-brand-line hidden md:block" />
            <div className="space-y-8">
              {APPOINTMENT_STEPS.map((a, i) => (
                <div
                  key={a.tag}
                  data-testid={`process-step-${i}`}
                  className="relative md:pl-16 bg-white rounded-2xl border border-brand-line/60 p-7 md:p-8 hover:shadow-md transition-shadow"
                >
                  <span className="md:absolute md:left-0 md:top-8 inline-flex items-center justify-center w-10 h-10 rounded-full bg-brand-clay text-white font-serif text-lg shadow-md">
                    {i + 1}
                  </span>
                  <h3 className="font-serif text-2xl md:text-3xl text-brand-pine mb-2">
                    {a.title}
                  </h3>
                  <p className="text-brand-textMuted leading-relaxed">{a.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
